import { render, staticRenderFns } from "./TypeTextImagePanel.vue?vue&type=template&id=59c4c432&scoped=true"
import script from "./TypeTextImagePanel.vue?vue&type=script&lang=js"
export * from "./TypeTextImagePanel.vue?vue&type=script&lang=js"
import style0 from "./TypeTextImagePanel.vue?vue&type=style&index=0&id=59c4c432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c4c432",
  null
  
)

export default component.exports